import { CSSProperties } from "react"
import { useCurrentLocale } from "../../../../../../packages/localization/client-side/useLocalize"
import { LocaleKey } from "../../../../../../packages/localization/Locale"

type WidgetAttributes = {
    token: string
    templateId: string
    height: number | string
    width: number | string
}

type WidgetName =
    | "microStar"
    | "microTrustScore"
    | "microCombo"
    | "horizontal"
    | "carousel"
    | "mini"
    | "grid"

const businessUnitId = "672c896cd556aafe9ee4561a"
const widgets: Record<WidgetName, WidgetAttributes> = {
    microStar: {
        templateId: "5419b732fbfb950b10de65e5",
        token: "271f0e22-8400-4783-bce4-0b6d900f0364",
        height: 24,
        width: "100%",
    },
    microTrustScore: {
        templateId: "5419b637fa0340045cd0c936",
        token: "ffc087ab-6c6f-4141-a447-3d1b97e369ad",
        height: 20,
        width: "100%",
    },
    microCombo: {
        templateId: "5419b6ffb0d04a076446a9af",
        token: "be0db333-f466-4e29-8912-665aad087f0e",
        height: 20,
        width: "100%",
    },
    horizontal: {
        templateId: "5406e65db0d04a09e042d5fc",
        token: "08161f74-8a5d-4e9c-98e5-b718063bf179",
        height: 28,
        width: "100%",
    },
    carousel: {
        templateId: "53aa8912dec7e10d38f59f36",
        token: "21fdcf85-ae85-41af-bd20-a8eb5175590e",
        height: 140,
        width: "100%",
    },
    mini: {
        templateId: "53aa8807dec7e10d38f59f32",
        token: "a234dfee-cbb1-401a-9ae8-c4c5f0bbfe79",
        height: 100,
        width: 150,
    },
    grid: {
        templateId: "539adbd6dec7e10e686debee",
        token: "e340a0d0-dbf9-4b88-b26c-7750702a69a9",
        height: 500,
        width: "100%",
    },
} as const

type BaseWidgetProps = {
    width?: string | number
    height?: string | number
    style?: CSSProperties
}

type WidgetProps = BaseWidgetProps &
    (
        | {
              widget: "carousel" | "grid"
              stars?: number[]
          }
        | {
              widget: Exclude<WidgetName, "carousel" | "grid">
          }
    )

export function TrustpilotWidget(props: WidgetProps) {
    const locale = useCurrentLocale()

    const widget = widgets[props.widget]
    const h = props.height ?? widget.height
    const w = props.width ?? widget.width

    return (
        <div
            style={props.style}
            className="trustpilot-widget"
            data-locale={locale === LocaleKey("no") ? "nb-NO" : "en-GB"}
            data-businessunit-id={businessUnitId}
            data-style-height={typeof h === "number" ? `${h}px` : h}
            data-style-width={typeof w === "number" ? `${w}px` : w}
            data-template-id={widget.templateId}
            data-token={widget.token}
            data-stars={
                props.widget === "carousel" || props.widget === "grid"
                    ? props.stars
                        ? props.stars.join(",")
                        : "1,2,3,4,5"
                    : undefined
            }
        >
            <a href="https://no.trustpilot.com/review/redoit.no" target="_blank" rel="noopener">
                Trustpilot
            </a>
        </div>
    )
}
